/* eslint-disable no-console */
import React, { useEffect } from 'react';
import { useLocation, useParams } from 'react-router';
import { Helmet } from 'react-helmet-async';
import { StaticContext } from 'global';
import { PetInterface } from 'types/pet';
import { useQuery } from 'react-query';
import FetchError from 'types/http';
import PageLoader from '../components/loaders/PageLoader';
import { getPet } from '../../shared/api/petApi';
import { retryCount } from '../../shared/util/reactQueryOptions';
import { ACCOUNT_OVERVIEW_PATH } from '../../shared/util/config';
import Error from '../components/Error';
import './error-page.scss';

interface Props {
  staticContext?: StaticContext;
  error?: any;
}

export default function Error500({ staticContext, error }: Props) {
  const { pathname } = useLocation();
  if (staticContext) {
    staticContext.statusCode = error.status || 500;
    staticContext.error = error;
  }

  const { petId } = useParams<{ petId: string }>();

  const petProfileQuery = useQuery<PetInterface, FetchError>([getPet.key, petId], getPet, {
    retry: retryCount,
  });

  const deletedPet = !petProfileQuery.data;
  const isLoading = petProfileQuery.isLoading;

  useEffect(() => {
    if (deletedPet) window.location.href = ACCOUNT_OVERVIEW_PATH;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deletedPet]);

  return !isLoading ? (
    <Error title="Oops!" staticContext={staticContext}>
      <Helmet>
        <title>Chewy.com Error</title>
      </Helmet>
      <div>
        An unexpected error occurred while loading{' '}
        <pre className="chewy-error__pathname">{pathname}</pre>
      </div>
    </Error>
  ) : (
    <PageLoader />
  );
}
